const DIGIT_RUN = /[0-9](?:[\s./_\p{Pd}]*[0-9])*/gu;
const MIN_PAN_LENGTH = 13;
const MAX_PAN_LENGTH = 19;
const MAX_WHOLE_RUN_LENGTH = 16;

const passesLuhn = (digits: string): boolean => {
    let sum = 0;
    let double = false;

    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = Number(digits[i]);
        if (double) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        double = !double;
    }

    return sum % 10 === 0;
};

/** Up to 16 digits is checked whole; a longer run is scanned for any Luhn-valid 13-19 digit window. */
const runContainsCardNumber = (digits: string): boolean => {
    if (digits.length < MIN_PAN_LENGTH) return false;
    if (digits.length <= MAX_WHOLE_RUN_LENGTH) return passesLuhn(digits);

    for (let windowLength = MIN_PAN_LENGTH; windowLength <= Math.min(MAX_PAN_LENGTH, digits.length); windowLength++) {
        for (let offset = 0; offset + windowLength <= digits.length; offset++) {
            if (passesLuhn(digits.slice(offset, offset + windowLength))) return true;
        }
    }

    return false;
};

/** Mirrors the backend NoPrimaryAccountNumber rule so the two reject the same input. */
export const looksLikeCardNumber = (value: string): boolean =>
    (value.match(DIGIT_RUN) ?? []).some((run) => runContainsCardNumber(run.replace(/[^0-9]/g, '')));
